var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-row",
    { attrs: { "vs-justify": "center" } },
    [
      _c(
        "vs-col",
        {
          attrs: {
            type: "flex",
            "vs-justify": "center",
            "vs-align": "center",
            "vs-w": "10"
          }
        },
        [
          _c(
            "b-card",
            { attrs: { "title-color": "primary" } },
            [_c(_vm.resolvedType, { tag: "component" })],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }